module.exports = __webpack_public_path__ + "static/media/empresa.892aaf8a.jpg";